<template>
    <v-card outline class="xs12 lg3 ma-2">
        <v-list-item three-line>
        <v-list-item-content>
            <div class="overline mb-4">{{manager.position}}</div>
            <v-list-item-title>{{manager.name}}</v-list-item-title>
            <v-list-item-subtitle v-if="manager.telephone">Tel.: {{manager.telephone}}</v-list-item-subtitle>

        </v-list-item-content>
            <v-list-item-avatar
                    height="136"
                    width="100"
                    tile
            ><v-img :src="require(`../assets/${manager.img || 'profile.png'}`)"></v-img></v-list-item-avatar>
        </v-list-item>


        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="manager.telephone" color="#e35d32" class="white--text"  tile :href="`tel:${manager.telephone.replace(`/`, '')}`">
            <v-icon>mdi-phone</v-icon>
          </v-btn>
            <v-btn color="#e35d32" class="white--text" tile :href="getMailLink"><v-icon>mdi-email-plus</v-icon></v-btn>

        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        props: ['manager'],
        computed: {
            getMailLink () {
                return `mailto:${this.manager.email}`
            }
        }
    }
</script>
